import * as React from 'react';
import {withTooltip} from './HOC/withTooltip';

interface ImgProps {
    alt?: string;
    src: any;
}

const Img = ({alt, src}: ImgProps) => <img alt={alt} src={src} />;

const TooltipedImg = withTooltip(Img);

export default TooltipedImg;
